import React, { useRef, useState } from "react"
import s from "./Tooltip.module.scss"
import cn from "classnames"
import { useSettings } from "../../layout/page/settingsContext"
import { isMobile } from "src/utils"

export default function Tooltip({ children }: { children: React.ReactNode }) {
    const [open, setOpen] = useState(false)
    const { translations: t } = useSettings()
    const outerRef = useRef<HTMLButtonElement>()
    const tooltipRef = useRef<HTMLDivElement>()

    if (!children) {
        return null
    }
    const clickHandler = (tooltipEvent) => {
        if (isMobile) {
            const { left } = outerRef.current.getBoundingClientRect()
            tooltipRef.current.style.marginLeft = `calc(-${left}px + 50vw)`
        }

        setOpen(!open)

        // Attach clickHandler to document to catch when a new click is made to dismiss the tooltip
        const blurClickHandler = (outsideEvent) => {
            if (!(tooltipEvent.target as HTMLElement).contains(outsideEvent.target)) {
                setOpen(false)
            }
            document.removeEventListener("click", blurClickHandler)
        }
        setTimeout(() => {
            document.addEventListener("click", blurClickHandler)
        }, 1)
    }

    return (
        <div className={cn(s.tooltip, { [s["tooltip--open"]]: open })}>
            <button
                className={s.tooltip__button}
                ref={outerRef}
                type="button"
                onClick={clickHandler}
                aria-label={t?.tooltip?.open}
                aria-haspopup="true"
                aria-expanded={open}
                aria-controls="tooltip-text"
                aria-describedby="tooltip-text"
                title={t?.tooltip?.open || "Open tooltip"}
            >
                ?<span className="visually-hidden">{t?.tooltip?.open}</span>
            </button>
            <div
                className={s.tooltip__text}
                style={{
                    // marginLeft: offset,
                    display: open ? "block" : "none",
                }}
                ref={tooltipRef}
                id="tooltip-text"
                role="tooltip"
            >
                {children}
            </div>
        </div>
    )
}
